import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHeader } from "@/components/PageHeader";
import { Portfolio } from "@/components/Portfolio";
import { CTASection } from "@/components/CTASection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function WorkPage() {
  usePageMeta({
    title: "Work | BrandZenith",
    description:
      "BrandZenith concept work — AI campaigns, social content, brand identities, websites, reels and cinematic visuals. Real client projects live here as they launch.",
    path: "/work",
  });

  return (
    <>
      <Navbar />
      <main>
        <PageHeader
          overline="Selected Work"
          title="Work that"
          accent="moves brands."
          copy="A preview of what BrandZenith creates — concept work today, your brand here tomorrow."
        />
        <Portfolio showHeader={false} />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
